import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const setReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_SET:
  case constants.SET_CREATE:
  case constants.DELETE_SET:
    return { ...state, loading: true };
  case constants.DELETE_SET_SUCCESS:
  case constants.GET_SET_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.DELETE_SET_ERROR:
  case constants.GET_SET_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.SET_CREATE_SUCCESS:
  case constants.SET_CREATE_ERROR:
    return { ...state, loading: false };
  case constants.RESET_SET:
    return initialState;
  default:
    return state;
  }
};
